module.exports = __webpack_public_path__ + "static/img/Andi_Kleissner_Amped.d74a2bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Andi_Kleissner_Amped.jpg
// module id = q9V3
// module chunks = 0